import AbstractItemResource from '../abstract/abstract-item-resource';
import {Resource} from 'sdk/src/defines';
import {DropDownItem} from '../../utility/types';
import {iso6393, iso6393To1, Language} from 'iso-639-3';

const ADDITIONAL_LANGUAGES_ISO6393: string[] = [
    'ady', 'dar', 'inh', 'kbd', 'kum', 'lbe', 'lez',
];

export const LANGUAGE_CODE_TO_LABEL_MAP: {[code: string]: string} = (()=> {
    const codeToLabelMap: {[code: string]: string} = {};
    const set: Set<string> = new Set<string>([...Object.keys(iso6393To1), ...ADDITIONAL_LANGUAGES_ISO6393]);

    iso6393.forEach((lang: Language) => {
        if (set.has(lang.iso6393)) {
            codeToLabelMap[lang.iso6391 ?? lang.iso6393] = lang.name;
        }
    });

    return codeToLabelMap;
})();

export type LanguageType = {
    code: string,
    language: string,
};

class Locale extends AbstractItemResource {
    public resourceType: Resource = Resource.LOCALES;

    public declare language: string;

    public declare locales: {[phrase: string]: string};

    public static languagesForDropDown(): DropDownItem[] {
        const data: DropDownItem[] = [];

        Object.keys(LANGUAGE_CODE_TO_LABEL_MAP).forEach((code: string) => {
            data.push({
                label: LANGUAGE_CODE_TO_LABEL_MAP[code],
                value: code,
            });
        });

        return data;
    }

    public static getLanguagesList(): LanguageType[] {
        return Object.keys(LANGUAGE_CODE_TO_LABEL_MAP).map((code: string): LanguageType => {
            return {
                code,
                language: LANGUAGE_CODE_TO_LABEL_MAP[code],
            };
        });
    }

    public static getLanguageLabelByCode(code: string): string {
        return LANGUAGE_CODE_TO_LABEL_MAP[code];
    }

    public getLanguageStr(): string {
        return LANGUAGE_CODE_TO_LABEL_MAP[this.language] ?? null;
    }

}

export default Locale;
